import React, { type Ref } from "react";

import clsx from "clsx";

import { type TableSelection } from "@devexpress/dx-react-grid-bootstrap4";
import { Checkbox } from "@shared/checkbox";

export const TableSelectCell = ({
  selected,
  onToggle,
  row,
  tableRow,
  tableColumn,
  forwardedRef,
  ...restProps
}: TableSelection.CellProps & { forwardedRef?: Ref<any> }) => {
  const isBreakdown = !row?.link || Object.keys(row.link).length === 0;
  const isPlatformView = row?.rowMetadata?.isPlatformView;
  const isSelectable = isPlatformView || !isBreakdown;

  return (
    <td
      className={clsx("text-center align-middle")}
      ref={forwardedRef}
      {...restProps}
      onClick={() => isSelectable && onToggle()}
    >
      {isSelectable && (
        <Checkbox
          className="inline-block dx-g-bs4-cursor-pointer"
          value={selected}
        />
      )}
    </td>
  );
};
